/* ==========================================================================
   Shipping Info Drawer - Web Component
   ========================================================================== */

class ShippingInfoDrawer extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('.shipping-drawer__overlay');
    this.closeBtn = this.querySelector('.shipping-drawer__close');
    this.accordions = this.querySelectorAll('[data-accordion]');

    this.overlay?.addEventListener('click', () => this.close());
    this.closeBtn?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('active')) this.close();
    });

    // Accordion toggles — exclusive (only one open at a time)
    this.accordions.forEach(accordion => {
      const trigger = accordion.querySelector('[data-accordion-trigger]');
      trigger?.addEventListener('click', () => {
        const isOpen = accordion.classList.contains('is-open');
        // Close all accordions first
        this.accordions.forEach(a => a.classList.remove('is-open'));
        // Toggle the clicked one (open if it was closed)
        if (!isOpen) {
          accordion.classList.add('is-open');
        }
      });
    });
  }

  open(tab) {
    this.classList.add('active');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    // If a specific tab is requested, open it and close others
    if (tab) {
      this.accordions.forEach(accordion => {
        const trigger = accordion.querySelector('[data-accordion-trigger]');
        const triggerTab = trigger?.getAttribute('data-accordion-trigger');
        if (triggerTab === tab) {
          accordion.classList.add('is-open');
        } else {
          accordion.classList.remove('is-open');
        }
      });
    }
  }

  close() {
    this.classList.remove('active');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('shipping-info-drawer', ShippingInfoDrawer);

/* ==========================================================================
   Countdown Timer
   ========================================================================== */

function initShippingCountdown() {
  const countdownEl = document.getElementById('ShippingSameDayCountdown');
  if (!countdownEl) return;

  const cutoffHour = parseInt(countdownEl.dataset.cutoffHour || '17', 10);
  const cutoffMinute = parseInt(countdownEl.dataset.cutoffMinute || '0', 10);
  const timerEls = document.querySelectorAll('.shipping-info__timer');
  const countdownContainers = document.querySelectorAll('.shipping-info__countdown');

  function updateCountdown() {
    const now = new Date();
    const cutoff = new Date();
    cutoff.setHours(cutoffHour, cutoffMinute, 0, 0);

    // Check if it's a weekday (Mon-Fri) and before cutoff
    const day = now.getDay();
    const isWeekday = day >= 1 && day <= 5;
    const diff = cutoff - now;

    if (!isWeekday || diff <= 0) {
      countdownContainers.forEach(el => {
        el.style.display = 'none';
      });
      return;
    }

    const hours = Math.floor(diff / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    const timeStr = String(hours).padStart(2, '0') + ':' +
                    String(minutes).padStart(2, '0') + ':' +
                    String(seconds).padStart(2, '0');

    timerEls.forEach(el => {
      el.textContent = timeStr;
    });
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
}

/* ==========================================================================
   Init open buttons
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initShippingCountdown();

  document.querySelectorAll('[data-shipping-drawer-open]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const tab = btn.getAttribute('data-shipping-tab');
      document.getElementById('ShippingInfoDrawer')?.open(tab);
    });
  });
});
